import { createClient } from '@supabase/supabase-js';
import { Database } from './database.types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validate the Supabase URL and key
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables. Make sure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set in your .env file.');
}

// Create the Supabase client with retry capabilities
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true
  },
  global: {
    fetch: (...args) => {
      // Add a custom timeout to fetch requests
      const [resource, config] = args;
      return fetch(resource, {
        ...config,
        // Add a 15 second timeout
        signal: AbortSignal.timeout(15000)
      });
    }
  }
});

// Test if the Supabase client is initialized properly
if (!supabase) {
  console.error('Supabase client failed to initialize properly. Check your environment variables and network connection.');
}

// Add a health check function to test connectivity
export async function checkSupabaseConnection() {
  try {
    const { error } = await supabase.from('todos').select('count').limit(1);
    return !error;
  } catch (err) {
    console.error('Supabase connection test failed:', err);
    return false;
  }
}